<script lang="ts">
  import * as rive from '@rive-app/canvas';
  import { STATIC_URL } from '$lib/constants';

  export let username = 'Player1';

  let className = '';
  export { className as class };

  const rivFile = `${STATIC_URL}/animations/suit-up-text.riv`;
  let loaded = false;
  let animation;

  $: username && setName(username);

  function anim(node) {
    animation = new rive.Rive({
      src: rivFile,
      canvas: node,
      autoplay: true,
      stateMachines: 'interaction',
      onLoad: () => {
        animation.resizeDrawingSurfaceToCanvas();
        loaded = true;
        animation.setTextRunValue('TEXT_RUN', username);
      }
    });
    return {
      destroy() {
        animation && animation.cleanup();
        loaded = false;
      }
    };
  }

  function setName(name) {
    if (loaded && animation) {
      animation.setTextRunValue('TEXT_RUN', name);
    }
  }
</script>

<canvas
  use:anim
  class="suit-up-animation {className}"
  width="480"
  height="596"
  class:opacity-[0.01]={!loaded}
  class:animate-pop-in-slow={loaded}
></canvas>
